import { useEffect, useState } from "react";
import { SSOService } from "../../services/SSOService";
import { Stringutility } from "../../utilities/stringutility";

const SSOLogin = () => {
  const query = new URLSearchParams(window.location.search);
  useEffect(() => {
    let sso = "";
    let sig = "";
    if (!Stringutility.isNullOrEmpty(query.get("sso"))) {
      sso = query.get("sso");
    }

    if (!Stringutility.isNullOrEmpty(query.get("sig"))) {
      sig = query.get("sig");
    }
    getSSODetails(sso,sig);
  }, [0]);

  const getSSODetails = (sso,sig) => {    
    SSOService.getSSODetails(sso,sig).then((response) => {
      let ssoLoginDetails = response.data;
      if (ssoLoginDetails != null) {       
        let uri='';
        if(!Stringutility.isNullOrEmpty(ssoLoginDetails.uri)){
          uri=ssoLoginDetails.uri;
        }
        let query='';
        if(!Stringutility.isNullOrEmpty(ssoLoginDetails.query)){
          query=ssoLoginDetails.query;
        }
        let url=uri+query;
         window.open(url,"_self")
      }
    });
  };

  return <div></div>;
};

export default SSOLogin;
